// Copyright (c) 2017 Deere & Company

import {routerActions} from 'react-router-redux';

export const goToSearchView = searchQuery =>
    routerActions.push(`/products/search?by=PIN&q=${searchQuery}`);



// WEBPACK FOOTER //
// ./src/app/action-creators/go-to-search-view.js